var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-start align-center"},[_c('v-avatar',{staticClass:"mr-3",attrs:{"size":30,"color":"snow"}},[_c('div',{staticClass:"smoke--text",staticStyle:{"width":"16px","height":"16px"}},[_c('LinkMiniIcon',{attrs:{"size":16}})],1)]),_c('div',{staticClass:"body-2"},[_vm._v(" "+_vm._s(_vm.$tr('project', 'key_63'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }